import { render, staticRenderFns } from "./PdfWidgetPanel.vue?vue&type=template&id=54170b66&scoped=true"
import script from "./PdfWidgetPanel.vue?vue&type=script&lang=js"
export * from "./PdfWidgetPanel.vue?vue&type=script&lang=js"
import style0 from "./PdfWidgetPanel.vue?vue&type=style&index=0&id=54170b66&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54170b66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54170b66')) {
      api.createRecord('54170b66', component.options)
    } else {
      api.reload('54170b66', component.options)
    }
    module.hot.accept("./PdfWidgetPanel.vue?vue&type=template&id=54170b66&scoped=true", function () {
      api.rerender('54170b66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/templates/editor/settingPanel/PdfWidgetPanel.vue"
export default component.exports